import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'semantic-ui-css/semantic.min.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(

    //when publishing remove the variable ->> ASPNETCORE_ENVIRONMENT  :  Development


    //<BrowserRouter basename={baseUrl}>
    <BrowserRouter basename={'/loadbuilder'}>
        <App />
    </BrowserRouter>,
    rootElement);


registerServiceWorker();

